export class KeyValue {
  code: string;
  description: string;
  id: string;
  tag: string;
}
